import styled from 'styled-components'
import DesktopPurchaseDetail from 'components/desktop/page/Purchases/Detail'

const PurchaseDetail = styled(DesktopPurchaseDetail)``

export default PurchaseDetail
